import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { NakedButton } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import { useIsInView } from '@shared/v2/components/InView';

import { NavItem } from '../types';

const activeIndicator = ({ isActive, ...rest }: { isActive: boolean }) =>
  isActive &&
  css`
    color: ${themeGet('colors.brand.primary')(rest)};

    &::before {
      background: ${themeGet('colors.brand.primary')(rest)};
    }
  `;

const Button = styled(NakedButton)`
  line-height: 20px;
  position: relative;
  font-weight: bold;
  font-family: ${themeGet('headerFontFamily')};
  transition:
    color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  border-radius: 8px;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4px;
    border-radius: 4px;
    background: transparent;
    transition: background-color 0.3s ease-in-out;
  }

  :focus {
    outline: none;
  }

  :focus-visible {
    outline: 1px solid ${themeGet('colors.secondary')};
  }

  :hover {
    background-color: ${({ isActive }: { isActive: boolean }) =>
      isActive ? '' : themeGet('colors.lightGrey')};
  }

  ${activeIndicator}
`;

const NavButton = ({ navItem }: { navItem: NavItem; navHeight: number }) => {
  const { key, title } = navItem || {};
  const { isLatestInView, scrollIntoView } = useIsInView(key);

  const handleScroll = () => {
    scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Button
      data-testid={`IN_PAGE_NAV_BUTTON-${key}`}
      isActive={isLatestInView}
      p={4}
      onClick={handleScroll}
    >
      {title}
    </Button>
  );
};

export default NavButton;
